<template>
  <div>
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '285px' }">
      <div slot="title">
        <div class="radius"></div>
        <div class="radiusTitle">远传水表抄见率(当日)</div>
      </div>
      <div class="content">
        <BarEcharhlt :data="copyList" />
      </div>
    </a-card>

    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '285px', 'margin-top': '24px' }">
      <div slot="title">
        <div class="radius"></div>
        <div class="radiusSmallTitle">
          远传水表月度总售水量的
          <br />同比、环比
        </div>
      </div>
      <div slot="extra">
        <a-date-picker
          mode="year"
          placeholder="请选择年份"
          format="YYYY"
          v-model="selectyear"
          style="width: 120px"
          :open="yearShowOne"
          :defaultValue="moment(getCurrentData(), 'YYYY')"
          @openChange="openChangeOne"
          @panelChange="panelChangeOne"
        />
      </div>
      <div class="content">
        <BarLineEchart key="date1" :data="WaterWarningList"></BarLineEchart>
      </div>
    </a-card>
  </div>
</template>

<script>
import BarEcharhlt from './module/BarEcharhlt.vue'
import BarLineEchart from './module/BarLineEchart'
import moment from 'moment'
export default {
  name: 'RemoteZoneRight',
  components: {
    BarLineEchart,
    BarEcharhlt,
  },
  data() {
    return {
      userwaterList: {},
      WaterWarningList: {},
      copyList: {},
      selectyear: '',
      stringYear: '',
      yearShowOne: false,
    }
  },
  methods: {
    moment,
    getCurrentData() {
      return new Date().toLocaleDateString()
    },
    openChangeOne(status) {
      //status是打开或关闭的状态
      if (status) {
        this.yearShowOne = true
      }
    },
    change(val, string) {
      console.log(val.string)
    },
    panelChangeOne(value) {
      this.selectyear = value
      this.stringYear = moment(value).format('YYYY')
      this.yearShowOne = false
      this.getWaterList()
    },
    getWaterList() {
      //
      this.$http
        .get('/pipe-network/yc_user_remote_water_meters/sales/water', { params: { yearTime: this.stringYear } })
        .then((res) => {
          let datas = res.data
          let xData = []
          let saleData = []
          let tData = []
          let hData = []
          if (datas.length != null) {
            for (let i = 0; i < datas.length; i++) {
              // list.push({
              //   name: datas[i].time,
              //   value: datas[i].num,
              //   percentage: datas[i].percentage
              // })
              datas[i].data[0].presentNum = datas[i].data[0].presentNum
                ? parseFloat(datas[i].data[0].presentNum).toFixed(2)
                : datas[i].data[0].presentNum
              xData.push(datas[i].time + '月')
              saleData.push(datas[i].data[0].presentNum)
              tData.push(datas[i].data[0].pariPassuRatio)
              hData.push(datas[i].data[0].monthlyBasisRatio)
            }

            this.WaterWarningList = {
              xData: xData,
              saleData: saleData,
              tData: tData,
              hData: hData,
            }
          }
        })
    },
    getList() {
      //贸易结算表总供水量
      this.$http.get('/pipe-network/yc_user_remote_water_meters/water/total-supply').then((res) => {
        
        let list = res.data
        var xdata = []
        var sdata = []
        list.map((item) => {
          item.time = item.time.substring(5, item.time.length)
          xdata.push(item.time)
          sdata.push(item.meterNumber)
        })
        this.userwaterList = {
          xdata: xdata,
          sdata: sdata,
          color: [
            new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#A381E6' }, //柱图渐变色
              { offset: 1, color: '#6146C5' }, //柱图渐变色
            ]),
          ],
          grid: {
            x: '28%', //左侧与y轴的距离
            // y:'2%', //top部与x轴的距离
            x2: '5%', //右侧与y轴的距离
            y2: '11%', //bottom部与x轴的距离
          },
        }
        console.log(this.userwaterList,'hjdfhdvhjdvcjhvdbfosbfgi')
      })

      //远传水表抄见率(当日)
      this.$http.get('/pipe-network/yc_user_remote_water_meters/copy/total-supply').then((res) => {
        
        let list = res.data
        var xdata = []
        var sdata = []
           var vdata = []
        list.map((item) => {
          item.meterNumber = Number(parseFloat(item.meterNumber).toFixed(2))
          xdata.push(item.time)
          sdata.push(item.meterNumber)
          vdata.push(item.value)
        })
        this.copyList = {
          xdata: xdata,
          sdata: sdata,
          vdata: vdata,
          color: [
            new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#FFCB54' }, //柱图渐变色
              { offset: 1, color: '#F69445' }, //柱图渐变色
            ]),
          ],
          grid: {
            x: '12%', //左侧与y轴的距离
            y: '18%', //top部与x轴的距离
            x2: '2%', //右侧与y轴的距离
            y2: '22%', //bottom部与x轴的距离
          },
          barwidth: 36,
          rotate: 0,
        }
      })
    },
  },
  created() {
    this.getList()
    this.getWaterList()
  },
}
</script>
<style lang="less" scoped>
.radius {
  float: left;
  width: 6px;
  height: 21px;
  background: #0265ff;
  border-radius: 3px;
}
.radiusTitle {
  margin-left: 10px;
  float: left;
  width: 100px;
  height: 21px;
  line-height: 21px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.radiusSmallTitle {
  margin-left: 10px;
  float: left;
  width: 100px;
  height: 21px;
  line-height: 14px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.radioTitle {
  height: 29px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.56px;
  font-weight: 600;
}
/deep/ .ant-card-body {
  padding: 0;
}
/deep/.ant-card-extra {
  padding: 0;
}
/deep/.ant-card-head {
  //  padding: 0;
  padding-right: 2px;
}
</style>